import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import { Auth } from 'aws-amplify';
import Box from '@mui/system/Box';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { VERIFICATION_BASE_URL,
  EPISODE_2284_REFERENCE_DATA_URL,
  EPISODE_AUTHORIZATION_REFERENCE_DATA_URL,
  EPISODE_CMP_REFERENCE_DATA_URL, dateFormat  } from '../../constants';
import { _setIntMed } from '../../redux/verification/verificationActions';
import {
  getVerificationPopupSlice,
  setCheckAdm,
  setIntMed,
  setIntMedValueId,
  setIsDropDownCall,
  verificationsDialogPopupList,
} from '../../redux/verification/verificationDialogPopupData';
// import { useForm } from 'react-hook-form';
import {
  getCommonDropDown,
  getCommonDropDownDischarge1,
  getCommonDropDownDischarge2,
  getCommonDropDownDischarge3,
  getCommonDropDownDischarge4,
  getCommonDropDownDischarge5,
  getCommonDropDownDischarge6,
  getCommonDropDownDischarge7,
  getCommonDropDownGroup1,
  getCommonDropDownGroup2,
  getCommonDropDownGroup3,
  getCommonDropDownGroup4,
  getCommonDropDownGroup5,
  getCommonDropDownGroup6,
  getCommonDropDownGroup7,
  getCommonDropDownIndividual1,
  getCommonDropDownIndividual2,
  getCommonDropDownIndividual3,
  getCommonDropDownIndividual4,
  getCommonDropDownIndividual5,
  getCommonDropDownIndividual6,
  getCommonDropDownIndividual7,
} from './utils/utils';
import {
  getCallDischargeApi,
  getCallGroupApi,
  getCallIndividualApi,
} from './utils/utilsNew';
import VerificationDialog from './VerificationDialog';
import { getAuthReferenceData } from '../../redux/episode/authTab/authReferenceSlice';
import { get2284ReferenceData } from '../../redux/episode/2284Tab/2284Reference/2284ReferenceSlice';
import { getCmpReferenceData } from '../../redux/episode/cmpTab/cmpReference/cmpReferenceSlice';
import { singleEpisode } from '../../redux/episode/episodeSlice';
import { participant } from '../../redux/participant/participantSlice';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { getContactByUser } from '../Contact/services/contactsApi';

const VerificationTreatment = (props) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    verificationDataList,
    authToken,
    verifyModelList,
    monday,
    sunday,
    cbpValue,
    month,
    fetchVerify,
    canDisplayGroup
  } = props;
  const VerificationDialogPopup = useSelector(
    (state) => state.VerificationDialogPopupSlice?.VerificationDialogPopup
  );
  const [singleVarificationData, setSingleVarificationData] = useState({
    isLoading: true,
    data: [],
  });
  const [open, setOpen] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [latestTmtStsId, setLatestTmtStsId] = useState(0);
  const [checkAdmValue, setCheckAdmValue] = useState(false);
  const [latestUpdateField, setLatestUpdateField] = useState('');
  const [intMed, setIntMed] = useState(0);

  const verifyMasterReferenceData = useSelector(
    (state) => state.verifyMasterReferenceData
  );
  //console.log('### verifyMasterReferenceData');
  //console.log(verifyMasterReferenceData);


  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
  ]);

  //const getUser = () => {
  //  return Auth.currentAuthenticatedUser()
  //    .then((userData) => userData)
  //    .catch(() => console.log('Not signed in'));
  //};

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(function (user) {
        getContactByUser(user)
          .then(function (loggedInContact) {
            user.contact = loggedInContact;
          })
          .catch(() => console.log('Not signed in'));
        //console.log(user)
        return user;
      })
      .catch(() => console.log('Not signed in'));
  };

  let activeDateValue = monday;
  useEffect(() => {
    if (verificationDataList) {
      fetchData();
    }
    //else {
    //  setSingleVarificationData((prevState) => ({
    //    ...prevState,
    //    isLoading: false
    //  }));
    //}
  }, [verificationDataList]);

  useEffect(() => {
    if (
      VerificationDialogPopup?.isTmtStsId &&
      VerificationDialogPopup?.isStatusTag === 'Day'
    ) {
      FetchDropDown();
    }
    if (intMed === 0) {
      const intMedNewValue = intMed + 1;
      setIntMed(() => {
        return intMedNewValue;
      });
    }
  }, [checkAdmValue]);

  const fetchData = () => {
    setSingleVarificationData((prevState) => ({
      ...prevState,
      isLoading: false,
      data: verificationDataList?.map((item, index) => ({
        ...item,
        id: index,
        verPrtKey: item.verPrtKey,
        verPrtId: item.verPrtId,
        verIcnCDC: item.verIcnCDC,
        verEpdId: item.verEpdId,
        verSapAthId: item.verSapAthId,
        verSapAthMaxUnits: item.verSapAthMaxUnits,
        verSapAthMaxWkUnits: item.verSapAthMaxWkUnits,
      })),
    }));
  };

  const FetchDropDown = async (
    sapAthIdValue,
    verMinTmtDateValue,
    verSapAthAdmDateValue,
    verSapAthStartDateValue,
    verSapAthOvrlEndDateValue,
    i1TmtOrgInvBilledYnValue,
    i2TmtOrgInvBilledYnValue,
    i3TmtOrgInvBilledYnValue,
    i4TmtOrgInvBilledYnValue,
    i5TmtOrgInvBilledYnValue,
    i6TmtOrgInvBilledYnValue,
    i7TmtOrgInvBilledYnValue,
    g1TmtOrgInvBilledYnValue,
    g2TmtOrgInvBilledYnValue,
    g3TmtOrgInvBilledYnValue,
    g4TmtOrgInvBilledYnValue,
    g5TmtOrgInvBilledYnValue,
    g6TmtOrgInvBilledYnValue,
    g7TmtOrgInvBilledYnValue,
    d1TmtOrgInvBilledYnValue,
    d2TmtOrgInvBilledYnValue,
    d3TmtOrgInvBilledYnValue,
    d4TmtOrgInvBilledYnValue,
    d5TmtOrgInvBilledYnValue,
    d6TmtOrgInvBilledYnValue,
    d7TmtOrgInvBilledYnValue,
    i1TmtTmtStsIdValue,
    i2TmtTmtStsIdValue,
    i3TmtTmtStsIdValue,
    i4TmtTmtStsIdValue,
    i5TmtTmtStsIdValue,
    i6TmtTmtStsIdValue,
    i7TmtTmtStsIdValue,
    g1TmtTmtStsIDValue,
    g2TmtTmtStsIDValue,
    g3TmtTmtStsIDValue,
    g4TmtTmtStsIDValue,
    g5TmtTmtStsIDValue,
    g6TmtTmtStsIDValue,
    g7TmtTmtStsIDValue,
    d1TmtTmtStsIDValue,
    d2TmtTmtStsIDValue,
    d3TmtTmtStsIDValue,
    d4TmtTmtStsIDValue,
    d5TmtTmtStsIDValue,
    d6TmtTmtStsIDValue,
    d7TmtTmtStsIDValue
  ) => {
    const MinTmtDateValue =
      verMinTmtDateValue === undefined
        ? VerificationDialogPopup?.verMinTmtDate
        : verMinTmtDateValue;
    const SapAthAdmitDateValue =
      verSapAthAdmDateValue === undefined
        ? VerificationDialogPopup?.verSapAthAdmDate
        : verSapAthAdmDateValue;
    const SapAthStartDateValue =
      verSapAthStartDateValue === undefined
        ? VerificationDialogPopup?.verSapAthStartDate
        : verSapAthStartDateValue;
    const SapAthEndDateValue =
      verSapAthOvrlEndDateValue === undefined
        ? VerificationDialogPopup?.verSapAthOvrlEndDate
        : verSapAthOvrlEndDateValue;
    const sapAthId =
      sapAthIdValue === undefined
        ? VerificationDialogPopup?.verSapAthId
        : sapAthIdValue;
    const i1TmtOrgInvBilledYn =
      i1TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.i1TmtOrgInvBilledYn
        : i1TmtOrgInvBilledYnValue;
    const i2TmtOrgInvBilledYn =
      i2TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.i2TmtOrgInvBilledYn
        : i2TmtOrgInvBilledYnValue;
    const i3TmtOrgInvBilledYn =
      i3TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.i3TmtOrgInvBilledYn
        : i3TmtOrgInvBilledYnValue;
    const i4TmtOrgInvBilledYn =
      i4TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.i4TmtOrgInvBilledYn
        : i4TmtOrgInvBilledYnValue;
    const i5TmtOrgInvBilledYn =
      i1TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.i5TmtOrgInvBilledYn
        : i5TmtOrgInvBilledYnValue;
    const i6TmtOrgInvBilledYn =
      i6TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.i6TmtOrgInvBilledYn
        : i6TmtOrgInvBilledYnValue;
    const i7TmtOrgInvBilledYn =
      i7TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.i7TmtOrgInvBilledYn
        : i7TmtOrgInvBilledYnValue;
    const g1TmtOrgInvBilledYn =
      g1TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.g1TmtOrgInvBilledYn
        : g1TmtOrgInvBilledYnValue;
    const g2TmtOrgInvBilledYn =
      g2TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.g2TmtOrgInvBilledYn
        : g2TmtOrgInvBilledYnValue;
    const g3TmtOrgInvBilledYn =
      g3TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.g3TmtOrgInvBilledYn
        : g3TmtOrgInvBilledYnValue;
    const g4TmtOrgInvBilledYn =
      g4TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.g4TmtOrgInvBilledYn
        : g4TmtOrgInvBilledYnValue;
    const g5TmtOrgInvBilledYn =
      g5TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.g5TmtOrgInvBilledYn
        : g5TmtOrgInvBilledYnValue;
    const g6TmtOrgInvBilledYn =
      g6TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.g6TmtOrgInvBilledYn
        : g6TmtOrgInvBilledYnValue;
    const g7TmtOrgInvBilledYn =
      g7TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.g7TmtOrgInvBilledYn
        : g7TmtOrgInvBilledYnValue;
    const d1TmtOrgInvBilledYn =
      d1TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.d1TmtOrgInvBilledYn
        : d1TmtOrgInvBilledYnValue;
    const d2TmtOrgInvBilledYn =
      d2TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.d2TmtOrgInvBilledYn
        : d2TmtOrgInvBilledYnValue;
    const d3TmtOrgInvBilledYn =
      d3TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.d3TmtOrgInvBilledYn
        : d3TmtOrgInvBilledYnValue;
    const d4TmtOrgInvBilledYn =
      d4TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.d4TmtOrgInvBilledYn
        : d4TmtOrgInvBilledYnValue;
    const d5TmtOrgInvBilledYn =
      d5TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.d5TmtOrgInvBilledYn
        : d5TmtOrgInvBilledYnValue;
    const d6TmtOrgInvBilledYn =
      d6TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.d6TmtOrgInvBilledYn
        : d6TmtOrgInvBilledYnValue;
    const d7TmtOrgInvBilledYn =
      d7TmtOrgInvBilledYnValue === undefined
        ? VerificationDialogPopup?.d7TmtOrgInvBilledYn
        : d7TmtOrgInvBilledYnValue;
    const i1TmtStsId =
      i1TmtTmtStsIdValue === undefined
        ? VerificationDialogPopup?.i1TmtTmtStsId
        : i1TmtTmtStsIdValue;
    const i2TmtStsId =
      i2TmtTmtStsIdValue === undefined
        ? VerificationDialogPopup?.i2TmtTmtStsId
        : i2TmtTmtStsIdValue;
    const i3TmtStsId =
      i3TmtTmtStsIdValue === undefined
        ? VerificationDialogPopup?.i3TmtTmtStsId
        : i3TmtTmtStsIdValue;
    const i4TmtStsId =
      i4TmtTmtStsIdValue === undefined
        ? VerificationDialogPopup?.i4TmtTmtStsId
        : i4TmtTmtStsIdValue;
    const i5TmtStsId =
      i5TmtTmtStsIdValue === undefined
        ? VerificationDialogPopup?.i5TmtTmtStsId
        : i5TmtTmtStsIdValue;
    const i6TmtStsId =
      i6TmtTmtStsIdValue === undefined
        ? VerificationDialogPopup?.i6TmtTmtStsId
        : i6TmtTmtStsIdValue;
    const i7TmtStsId =
      i7TmtTmtStsIdValue === undefined
        ? VerificationDialogPopup?.i7TmtTmtStsId
        : i7TmtTmtStsIdValue;
    const g1TmtStsId =
      g1TmtTmtStsIDValue === undefined
        ? VerificationDialogPopup?.g1TmtTmtStsId
        : g1TmtTmtStsIDValue;
    const g2TmtStsId =
      g2TmtTmtStsIDValue === undefined
        ? VerificationDialogPopup?.g2TmtTmtStsId
        : g2TmtTmtStsIDValue;
    const g3TmtStsId =
      g3TmtTmtStsIDValue === undefined
        ? VerificationDialogPopup?.g3TmtTmtStsId
        : g3TmtTmtStsIDValue;
    const g4TmtStsId =
      g4TmtTmtStsIDValue === undefined
        ? VerificationDialogPopup?.g4TmtTmtStsId
        : g4TmtTmtStsIDValue;
    const g5TmtStsId =
      g5TmtTmtStsIDValue === undefined
        ? VerificationDialogPopup?.g5TmtTmtStsId
        : g5TmtTmtStsIDValue;
    const g6TmtStsId =
      g6TmtTmtStsIDValue === undefined
        ? VerificationDialogPopup?.g6TmtTmtStsId
        : g6TmtTmtStsIDValue;
    const g7TmtStsId =
      g7TmtTmtStsIDValue === undefined
        ? VerificationDialogPopup?.g7TmtTmtStsId
        : g7TmtTmtStsIDValue;
    if (VerificationDialogPopup?.isStatusTag === 'Day') {
      if (VerificationDialogPopup?.isTmtStsId === 15) {
        setCheckAdmValue((prevValue) => {
          return prevValue ? prevValue : true;
        });
      }
      if (latestTmtStsId === 2) {
        let intMedNewValue = intMed + 1;
        setIntMed(() => {
          return intMedNewValue;
        });
      }
      if (
        latestTmtStsId === 18 ||
        latestTmtStsId === 19 ||
        latestTmtStsId === 6
      ) {
        if (intMed > 0) {
          let intMedNegValue = '';
          if (intMed > 0 && intMed <= 3) {
            intMedNegValue = intMed;
          }
          setIntMed(() => {
            return intMedNegValue;
          });
        }
      }
    }
    getCallIndividualApi(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i1TmtOrgInvBilledYn,
      i2TmtOrgInvBilledYn,
      i3TmtOrgInvBilledYn,
      i4TmtOrgInvBilledYn,
      i5TmtOrgInvBilledYn,
      i6TmtOrgInvBilledYn,
      i7TmtOrgInvBilledYn,
      getCommonDropDownIndividual1,
      getCommonDropDownIndividual2,
      getCommonDropDownIndividual3,
      getCommonDropDownIndividual4,
      getCommonDropDownIndividual5,
      getCommonDropDownIndividual6,
      getCommonDropDownIndividual7,
      latestUpdateField,
      i1TmtStsId,
      i2TmtStsId,
      i3TmtStsId,
      i4TmtStsId,
      i5TmtStsId,
      i6TmtStsId,
      i7TmtStsId,
      latestTmtStsId
    );
    getCallGroupApi(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g1TmtOrgInvBilledYn,
      g2TmtOrgInvBilledYn,
      g3TmtOrgInvBilledYn,
      g4TmtOrgInvBilledYn,
      g5TmtOrgInvBilledYn,
      g6TmtOrgInvBilledYn,
      g7TmtOrgInvBilledYn,
      getCommonDropDownGroup1,
      getCommonDropDownGroup2,
      getCommonDropDownGroup3,
      getCommonDropDownGroup4,
      getCommonDropDownGroup5,
      getCommonDropDownGroup6,
      getCommonDropDownGroup7,
      latestUpdateField,
      g1TmtStsId,
      g2TmtStsId,
      g3TmtStsId,
      g4TmtStsId,
      g5TmtStsId,
      g6TmtStsId,
      g7TmtStsId
    );
    getCallDischargeApi(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d1TmtOrgInvBilledYn,
      d2TmtOrgInvBilledYn,
      d3TmtOrgInvBilledYn,
      d4TmtOrgInvBilledYn,
      d5TmtOrgInvBilledYn,
      d6TmtOrgInvBilledYn,
      d7TmtOrgInvBilledYn,
      getCommonDropDownDischarge1,
      getCommonDropDownDischarge2,
      getCommonDropDownDischarge3,
      getCommonDropDownDischarge4,
      getCommonDropDownDischarge5,
      getCommonDropDownDischarge6,
      getCommonDropDownDischarge7,
      latestUpdateField
    );
  };

  const verificationTreatmentRowClick = (row) => {
    const verificationTreatmentVerifyList = {
      stop1Hours: row.stop1Hours,
      stop2Hours: row.stop2Hours,
      stop3Hours: row.stop3Hours,
      stop4Hours: row.stop4Hours,
      stop5Hours: row.stop5Hours,
      stop6Hours: row.stop6Hours,
      stop7Hours: row.stop7Hours,
      verId: row.verId,
      verPrtId: row.verPrtId,
      verPrtKey: row.verPrtKey,
      verIcnCDC: row.verIcnCDC,
      verCboId: row.verCboId,
      verEpdId: row.verEpdId,
      verSapAthId: row.verSapAthId,
      verMinTmtDate: row.verMinTmtDate,
      verSapAthAdmDate: row.verSapAthAdmDate,
      verSapAthMaxUnits: row.verSapAthMaxUnits,
      verSapAthMaxWkUnits: row.verSapAthMaxWkUnits,
      verSapAthStartDate: row.verSapAthStartDate,
      verSapAthOvrlEndDate: row.verSapAthOvrlEndDate,
      verSapAthMaxIndUnits: row.verSapAthMaxIndUnits,
      verSapAthMaxGrpUnits: row.verSapAthMaxGrpUnits,
      i1TmtCboAthId: row.i1TmtCboAthId,
      i2TmtCboAthId: row.i2TmtCboAthId,
      i3TmtCboAthId: row.i3TmtCboAthId,
      i4TmtCboAthId: row.i4TmtCboAthId,
      i5TmtCboAthId: row.i5TmtCboAthId,
      i6TmtCboAthId: row.i6TmtCboAthId,
      i7TmtCboAthId: row.i7TmtCboAthId,
      g1TmtCboAthId: row.g1TmtCboAthId,
      g2TmtCboAthId: row.g2TmtCboAthId,
      g3TmtCboAthId: row.g3TmtCboAthId,
      g4TmtCboAthId: row.g4TmtCboAthId,
      g5TmtCboAthId: row.g5TmtCboAthId,
      g6TmtCboAthId: row.g6TmtCboAthId,
      g7TmtCboAthId: row.g7TmtCboAthId,
      d1TmtCboAthId: row.d1TmtCboAthId,
      d2TmtCboAthId: row.d2TmtCboAthId,
      d3TmtCboAthId: row.d3TmtCboAthId,
      d4TmtCboAthId: row.d4TmtCboAthId,
      d5TmtCboAthId: row.d5TmtCboAthId,
      d6TmtCboAthId: row.d6TmtCboAthId,
      d7TmtCboAthId: row.d7TmtCboAthId,
      i1TmtTmtStsId: row.i1TmtTmtStsId,
      i2TmtTmtStsId: row.i2TmtTmtStsId,
      i3TmtTmtStsId: row.i3TmtTmtStsId,
      i4TmtTmtStsId: row.i4TmtTmtStsId,
      i5TmtTmtStsId: row.i5TmtTmtStsId,
      i6TmtTmtStsId: row.i6TmtTmtStsId,
      i7TmtTmtStsId: row.i7TmtTmtStsId,
      g1TmtTmtStsId: row.g1TmtTmtStsId,
      g2TmtTmtStsId: row.g2TmtTmtStsId,
      g3TmtTmtStsId: row.g3TmtTmtStsId,
      g4TmtTmtStsId: row.g4TmtTmtStsId,
      g5TmtTmtStsId: row.g5TmtTmtStsId,
      g6TmtTmtStsId: row.g6TmtTmtStsId,
      g7TmtTmtStsId: row.g7TmtTmtStsId,
      d1TmtTmtStsId: row.d1TmtTmtStsId,
      d2TmtTmtStsId: row.d2TmtTmtStsId,
      d3TmtTmtStsId: row.d3TmtTmtStsId,
      d4TmtTmtStsId: row.d4TmtTmtStsId,
      d5TmtTmtStsId: row.d5TmtTmtStsId,
      d6TmtTmtStsId: row.d6TmtTmtStsId,
      d7TmtTmtStsId: row.d7TmtTmtStsId,
      i1TmtFaceHours: row.i1TmtFaceHours,
      i2TmtFaceHours: row.i2TmtFaceHours,
      i3TmtFaceHours: row.i3TmtFaceHours,
      i4TmtFaceHours: row.i4TmtFaceHours,
      i5TmtFaceHours: row.i5TmtFaceHours,
      i6TmtFaceHours: row.i6TmtFaceHours,
      i7TmtFaceHours: row.i7TmtFaceHours,
      i1TmtFaceMins: row.i1TmtFaceMins,
      i2TmtFaceMins: row.i2TmtFaceMins,
      i3TmtFaceMins: row.i3TmtFaceMins,
      i4TmtFaceMins: row.i4TmtFaceMins,
      i5TmtFaceMins: row.i5TmtFaceMins,
      i6TmtFaceMins: row.i6TmtFaceMins,
      i7TmtFaceMins: row.i7TmtFaceMins,
      i1TmtSuppHours: row.i1TmtSuppHours,
      i2TmtSuppHours: row.i2TmtSuppHours,
      i3TmtSuppHours: row.i3TmtSuppHours,
      i4TmtSuppHours: row.i4TmtSuppHours,
      i5TmtSuppHours: row.i5TmtSuppHours,
      i6TmtSuppHours: row.i6TmtSuppHours,
      i7TmtSuppHours: row.i7TmtSuppHours,
      i1TmtSuppMins: row.i1TmtSuppMins,
      i2TmtSuppMins: row.i2TmtSuppMins,
      i3TmtSuppMins: row.i3TmtSuppMins,
      i4TmtSuppMins: row.i4TmtSuppMins,
      i5TmtSuppMins: row.i5TmtSuppMins,
      i6TmtSuppMins: row.i6TmtSuppMins,
      i7TmtSuppMins: row.i7TmtSuppMins,
      i1TmtId: row.i1TmtId,
      i2TmtId: row.i2TmtId,
      i3TmtId: row.i3TmtId,
      i4TmtId: row.i4TmtId,
      i5TmtId: row.i5TmtId,
      i6TmtId: row.i6TmtId,
      i7TmtId: row.i7TmtId,
      g1TmtId: row.g1TmtId,
      g2TmtId: row.g2TmtId,
      g3TmtId: row.g3TmtId,
      g4TmtId: row.g4TmtId,
      g5TmtId: row.g5TmtId,
      g6TmtId: row.g6TmtId,
      g7TmtId: row.g7TmtId,
      d1TmtId: row.d1TmtId,
      d2TmtId: row.d2TmtId,
      d3TmtId: row.d3TmtId,
      d4TmtId: row.d4TmtId,
      d5TmtId: row.d5TmtId,
      d6TmtId: row.d6TmtId,
      d7TmtId: row.d7TmtId,
      i1TmtOrgInvBilledYn: row.i1TmtOrgInvBilledYn,
      i2TmtOrgInvBilledYn: row.i2TmtOrgInvBilledYn,
      i3TmtOrgInvBilledYn: row.i3TmtOrgInvBilledYn,
      i4TmtOrgInvBilledYn: row.i4TmtOrgInvBilledYn,
      i5TmtOrgInvBilledYn: row.i5TmtOrgInvBilledYn,
      i6TmtOrgInvBilledYn: row.i6TmtOrgInvBilledYn,
      i7TmtOrgInvBilledYn: row.i7TmtOrgInvBilledYn,
      g1TmtOrgInvBilledYn: row.g1TmtOrgInvBilledYn,
      g2TmtOrgInvBilledYn: row.g2TmtOrgInvBilledYn,
      g3TmtOrgInvBilledYn: row.g3TmtOrgInvBilledYn,
      g4TmtOrgInvBilledYn: row.g4TmtOrgInvBilledYn,
      g5TmtOrgInvBilledYn: row.g5TmtOrgInvBilledYn,
      g6TmtOrgInvBilledYn: row.g6TmtOrgInvBilledYn,
      g7TmtOrgInvBilledYn: row.g7TmtOrgInvBilledYn,
      d1TmtOrgInvBilledYn: row.d1TmtOrgInvBilledYn,
      d2TmtOrgInvBilledYn: row.d2TmtOrgInvBilledYn,
      d3TmtOrgInvBilledYn: row.d3TmtOrgInvBilledYn,
      d4TmtOrgInvBilledYn: row.d4TmtOrgInvBilledYn,
      d5TmtOrgInvBilledYn: row.d5TmtOrgInvBilledYn,
      d6TmtOrgInvBilledYn: row.d6TmtOrgInvBilledYn,
      d7TmtOrgInvBilledYn: row.d7TmtOrgInvBilledYn,
      intMedValue: 0,
      checkAdmValue: false,
    };
    dispatch(verificationsDialogPopupList(verificationTreatmentVerifyList));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1500);
    FetchDropDown(
      row.verSapAthId,
      row.verMinTmtDate,
      row.verSapAthAdmDate,
      row.verSapAthStartDate,
      row.verSapAthOvrlEndDate,
      row.i1TmtOrgInvBilledYn,
      row.i2TmtOrgInvBilledYn,
      row.i3TmtOrgInvBilledYn,
      row.i4TmtOrgInvBilledYn,
      row.i5TmtOrgInvBilledYn,
      row.i6TmtOrgInvBilledYn,
      row.i7TmtOrgInvBilledYn,
      row.g1TmtOrgInvBilledYn,
      row.g2TmtOrgInvBilledYn,
      row.g3TmtOrgInvBilledYn,
      row.g4TmtOrgInvBilledYn,
      row.g5TmtOrgInvBilledYn,
      row.g6TmtOrgInvBilledYn,
      row.g7TmtOrgInvBilledYn,
      row.d1TmtOrgInvBilledYn,
      row.d2TmtOrgInvBilledYn,
      row.d3TmtOrgInvBilledYn,
      row.d4TmtOrgInvBilledYn,
      row.d5TmtOrgInvBilledYn,
      row.d6TmtOrgInvBilledYn,
      row.d7TmtOrgInvBilledYn,
      row.i1TmtTmtStsId,
      row.i2TmtTmtStsId,
      row.i3TmtTmtStsId,
      row.i4TmtTmtStsId,
      row.i5TmtTmtStsId,
      row.i6TmtTmtStsId,
      row.i7TmtTmtStsId,
      row.g1TmtTmtStsId,
      row.g2TmtTmtStsId,
      row.g3TmtTmtStsId,
      row.g4TmtTmtStsId,
      row.g5TmtTmtStsId,
      row.g6TmtTmtStsId,
      row.g7TmtTmtStsId,
      row.d1TmtTmtStsId,
      row.d2TmtTmtStsId,
      row.d3TmtTmtStsId,
      row.d4TmtTmtStsId,
      row.d5TmtTmtStsId,
      row.d6TmtTmtStsId,
      row.d7TmtTmtStsId
    );
    setOpen(true);
  };

const episodeRowClick = (rowData) => {
    console.log('### CLICK FROM VERIFICATION LIST');
    console.log(rowData)

    const episode = [
      {
        episodeId: rowData.verEpdId,
      },
    ];
    const authReferenceUrl = `${EPISODE_AUTHORIZATION_REFERENCE_DATA_URL}/${rowData.verEpdId}/referencedata`;
    const reference2284Url = `${EPISODE_2284_REFERENCE_DATA_URL}/${rowData.verEpdId}`;
    const cmpReferenceUrl = `${EPISODE_CMP_REFERENCE_DATA_URL}/${rowData.verEpdId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getAuthReferenceData({ authReferenceUrl, authorization }));
    dispatch(get2284ReferenceData({ reference2284Url, authorization }));
    dispatch(getCmpReferenceData({ cmpReferenceUrl, authorization }));
    dispatch(singleEpisode(episode));
    
    const participantDetail = [
      {
        key: rowData.verPrtKey,
        id: rowData.verPrtId,
        //lastName: rowData.participant.lastName,
        //firstName: rowData.participant.firstName,
        //middleName: rowData.participant.middleName,
        //ssn: rowData.participant.SSN,
        //suffix: rowData.participant.suffix,
        //gender: rowData.episode.partcipant.gnd,
        //ethnicityOrRace: rowData.participant.ethnicityOrRace,
        //veteran: rowData.participant.veteran,
        //deployedCombatDuty: rowData.participant.deployedCombatDuty,
        //diagnosedPostTraumaticStressDisorder:
        //  rowData.participant.diagnosedPostTraumaticStressDisorder,
        //arsonist: rowData.arsonist,
        //dateOfBirth: rowData.participant.dateOfBirth,
        registration290: rowData.Prt290RegYN,
        //inactive: rowData.participant.inactive,
      },
    ];
    console.log('### PARTICIPANT DETAIL');
    console.log(participantDetail)  
    dispatch(participant(participantDetail));
    
    navigate(`/episode/details/${rowData.verEpdId}`);
  };

  const columnsData = [
    //{
    //  field: 'verify',
    //  headerName: '',
    //  minWidth: 80,
    //  renderCell: (params) => {
    //    return (
    //      <Button
    //        variant="contained"
    //        size="small"
    //        onClick={() => verificationTreatmentRowClick(params.row)}
    //      >
    //        Edit
    //      </Button>
    //    );
    //  },
    //  flex: 1,
    //},
    //{ field: 'verPrtId', headerName: 'PrtID', minWidth: 70 },
    { 
      field: 'verPrtKey', 
      headerName: 'Participant', 
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              <Typography variant='h6' fontWeight='700'>{params.value}</Typography>
            </Grid>
            <Grid item xs={12}>
              {params.row.verSapAthStartDate ?
                <Typography variant='h6'>Ath Start: {moment(params.row.verSapAthStartDate).format(dateFormat)}</Typography>
                : <Typography variant='h6'>Ath Start:</Typography>
              }   
            </Grid>
            <Grid item xs={12}>
              {params.row.verSapAthAdmDate ?
                <Typography variant='h6'>Ath Adm: {moment(params.row.verSapAthAdmDate).format(dateFormat)}</Typography>
                : <Typography variant='h6'>Ath Adm:</Typography>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.verSapAthDchDate ?
                <Typography variant='h6'>Ath Dch: {moment(params.row.verSapAthDchDate).format(dateFormat)}</Typography>
                : <Typography variant='h6'>Ath Dch:</Typography>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.verSapAthOvrlEndDate ?
                <Typography variant='h6'>Ath End: {moment(params.row.verSapAthOvrlEndDate).format(dateFormat)}</Typography>
                : <Typography variant='h6'>Ath End:</Typography>
              }  
            </Grid>
          </Grid>    
        )
      }
    },
    {
      field: 'verIcnCDC',
      headerName: 'CDC #',
      minWidth: 80,
      renderCell: (params) => {
        return (
          <Typography variant='h6'>{params.value}</Typography>
        )
      }    
    },
    {
      field: 'verEpdId',
      headerName: 'Epd ID',
      minWidth: 80,
      renderCell: (params) => {
        return (
          <Button
          variant="contained"
          size="small"
          onClick={() => episodeRowClick(params.row)}
        >
          {params.value}
        </Button>  
        )
      }
    },
    {
      field: 'tmtType',
      headerName: 'Tmt Type',
      maxWidth: 100,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              <Typography variant='h6'>Individual:</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='h6'>Group:</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='h6'>Discharge:</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='h6'>Hours:</Typography>
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: 'i1TmtTmtTypId',
      headerName: 'Monday ' + moment(monday).format(dateFormat),
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              {params.row.i1TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.i1TmtTmtStsIdList.find(x => x.id===params.row.i1TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.g1TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.g1TmtTmtStsIdList.find(x => x.id===params.row.g1TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.d1TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.d1TmtTmtStsIdList.find(x => x.id===params.row.d1TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.stop1Hours ?
                <Typography variant='h6'>{params.row.stop1Hours}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: 'i2TmtTmtTypId',
      headerName: 'Tuesday ' + moment(monday).add(1, 'd').format(dateFormat),
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              {params.row.i2TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.i2TmtTmtStsIdList.find(x => x.id===params.row.i2TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.g2TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.g2TmtTmtStsIdList.find(x => x.id===params.row.g2TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.d2TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.d2TmtTmtStsIdList.find(x => x.id===params.row.d2TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.stop2Hours ?
                <Typography variant='h6'>{params.row.stop2Hours}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
          </Grid>
        );
      },

    },
    {
      field: 'i3TmtTmtTypId',
      headerName: 'Wednesday ' + moment(monday).add(2, 'd').format(dateFormat),
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              {params.row.i3TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.i3TmtTmtStsIdList.find(x => x.id===params.row.i3TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.g3TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.g3TmtTmtStsIdList.find(x => x.id===params.row.g3TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.d3TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.d3TmtTmtStsIdList.find(x => x.id===params.row.d3TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.stop3Hours ?
                <Typography variant='h6'>{params.row.stop3Hours}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
          </Grid>
        );
      },

    },
    {
      field: 'i4TmtTmtTypId',
      headerName: 'Thursday ' + moment(monday).add(3, 'd').format(dateFormat),
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              {params.row.i4TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.i4TmtTmtStsIdList.find(x => x.id===params.row.i4TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.g4TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.g4TmtTmtStsIdList.find(x => x.id===params.row.g4TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.d4TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.d4TmtTmtStsIdList.find(x => x.id===params.row.d4TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.stop4Hours ?
                <Typography variant='h6'>{params.row.stop4Hours}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: 'i5TmtTmtTypId',
      headerName: 'Friday ' + moment(monday).add(4, 'd').format(dateFormat),
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              {params.row.i5TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.i5TmtTmtStsIdList.find(x => x.id===params.row.i5TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.g5TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.g5TmtTmtStsIdList.find(x => x.id===params.row.g5TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.d5TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.d5TmtTmtStsIdList.find(x => x.id===params.row.d5TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.stop5Hours ?
                <Typography variant='h6'>{params.row.stop5Hours}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
          </Grid>
        );
      },

    },
    {
      field: 'i6TmtTmtTypId',
      headerName: 'Saturday ' + moment(monday).add(5, 'd').format(dateFormat),
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              {params.row.i6TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.i6TmtTmtStsIdList.find(x => x.id===params.row.i6TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.g6TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.g6TmtTmtStsIdList.find(x => x.id===params.row.g6TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.d6TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.d6TmtTmtStsIdList.find(x => x.id===params.row.d6TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.stop6Hours ?
                <Typography variant='h6'>{params.row.stop6Hours}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: 'i7TmtTmtTypId',
      headerName: 'Sunday ' + moment(monday).add(6, 'd').format(dateFormat),
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <Grid item xs={12}>
              {params.row.i7TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.i7TmtTmtStsIdList.find(x => x.id===params.row.i7TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.g7TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.g7TmtTmtStsIdList.find(x => x.id===params.row.g7TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.d7TmtTmtStsId ?
                <Typography variant='h6'>{verifyMasterReferenceData.d7TmtTmtStsIdList.find(x => x.id===params.row.d7TmtTmtStsId).value.substring(0, 3)}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
            <Grid item xs={12}>
              {params.row.stop7Hours ?
                <Typography variant='h6'>{params.row.stop7Hours}</Typography>
                : <span>&nbsp;</span>
              }  
            </Grid>
          </Grid>
        );
      },
    },
  ];

  return (
    <>
      <DataGrid
        autoHeight
        hideFooter
        getRowHeight={() => 'auto'}
        columns={columnsData}
        rows={singleVarificationData.data}
        onRowClick={(param) => verificationTreatmentRowClick(param.row)}
        disableColumnFilter
        disableColumnMenu
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        loading={singleVarificationData.isLoading}
      />
      <VerificationDialog
        open={open}
        setOpen={setOpen}
        authToken={authToken}
        verifyModelList={verifyModelList}
        monday={monday}
        month={month}
        fetchVerify={fetchVerify}
        FetchDropDown={FetchDropDown}
        openBackdrop={openBackdrop}
        setIntMed={setIntMed}
        intMed={intMed}
        checkAdmValue={checkAdmValue}
        setCheckAdmValue={setCheckAdmValue}
        setLatestUpdateField={setLatestUpdateField}
        latestUpdateField={latestUpdateField}
        canDisplayGroup={canDisplayGroup}
        setLatestTmtStsId={setLatestTmtStsId}
        latestTmtStsId={latestTmtStsId}
        user={user}
      />
    </>
  );
};

export default VerificationTreatment;
